import { BackupSection } from './BackupSection';
import { RestoreSection } from './RestoreSection';
import './Settings.css';

/**
 * Living Spaces, not Pinterest: wide margins, few elements, lots of air.
 *
 * Two sections, because there are two things to do here. Link import had a
 * paragraph explaining itself, which is not a setting — it has no account and
 * no key to configure, and the place it's explained is the add-item dialog,
 * where you're already doing it.
 *
 * Storage had a section too, reporting whether the browser had promised to
 * keep the database. It's gone: a warning you can't act on beyond "make a
 * backup" is just the backup section again, said anxiously. The
 * `navigator.storage.persist()` request itself still runs on first launch —
 * see `db/settings.ts`. What went is the readout, not the protection.
 */
export function Settings() {
  return (
    <div className="settings">
      <h1 className="display settings__title">Settings</h1>

      <BackupSection />
      <RestoreSection />
    </div>
  );
}
